module.exports = __webpack_public_path__ + "img/yelp.2e9fa331.svg";